import { LoadingSkeleton } from 'sonata-react-components';

import { ListSkeletonStyled } from './ListSkeleton.styles';

export function ListSkeleton() {
  return (
    <ListSkeletonStyled className="listDiagnosisSkeleton">
      {Array.from({ length: 5 }).map((_, index) => (
        <div className="listDiagnosisSkeleton__item" key={index}>
          <LoadingSkeleton count={5} height={16} width={180} />
        </div>
      ))}
    </ListSkeletonStyled>
  );
}
